// Glas-Pille mit Icon, Label und ⇅; das native <select> liegt unsichtbar darüber
// (Tastatur, Mobil-Auswahl und Screenreader wie gewohnt). Handoff Selbstauskunft §2.2.
import type { CSSProperties } from 'react';
import { CaretUpDown, type Icon } from '@phosphor-icons/react';

export interface GlasAuswahlOption { wert: string; label: string }

export interface GlasAuswahlProps {
  wert: string;
  optionen: readonly GlasAuswahlOption[];
  onChange: (wert: string) => void;
  icon: Icon;
  ariaLabel: string;
  tip?: string;
  style?: CSSProperties;
  /** Beschriftung über dem Wert (Feld-Variante, 58 px hoch) */
  label?: string;
  gesperrt?: boolean;
}

export function GlasAuswahl({ wert, optionen, onChange, icon: I, ariaLabel, tip, style, label: feldLabel, gesperrt = false }: GlasAuswahlProps) {
  const label = optionen.find((o) => o.wert === wert)?.label ?? optionen[0]?.label ?? '';
  return (
    <div data-tip={tip} className="immo-glas immo-glas-auswahl relative flex min-w-0 items-center"
      style={{ height: feldLabel ? 58 : 44, borderRadius: feldLabel ? 16 : 22, padding: '0 14px', gap: 8, opacity: gesperrt ? 0.5 : 1, ...style }}>
      {feldLabel ? (
        <span className="flex min-w-0 flex-1 flex-col" style={{ gap: 2 }}>
          <span style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--ink3)' }}>{feldLabel}</span>
          <span className="flex min-w-0 items-center" style={{ gap: 7 }}>
            <I aria-hidden size={16} weight="fill" color="var(--acc)" className="shrink-0" />
            <span className="min-w-0 truncate" style={{ fontSize: 15, fontWeight: 800, color: 'var(--ink)' }}>{label}</span>
          </span>
        </span>
      ) : (
        <>
          <I aria-hidden size={16} weight="fill" color="var(--acc)" className="shrink-0" />
          <span className="min-w-0 flex-1 truncate" style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink)' }}>{label}</span>
        </>
      )}
      <CaretUpDown aria-hidden size={13} weight="bold" color="var(--ink3)" className="pointer-events-none shrink-0" />
      <select aria-label={ariaLabel} value={wert} onChange={(e) => onChange(e.target.value)} disabled={gesperrt}
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0" style={{ fontSize: 14 }}>
        {optionen.map((o) => <option key={o.wert} value={o.wert}>{o.label}</option>)}
      </select>
    </div>
  );
}
